import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyLanding } from "@/components/MatchKey/MatchKeyShell";
import { PENTE_CFG } from "@/components/MatchKey/cfgs";

export default function PenteLanding() {
  useEerieBackdrop("pente");
  return <MatchKeyLanding cfg={PENTE_CFG} />;
}
